// Pahar shop — buy straight from the card.
//
// One option (Size), so a card holds the whole decision: tap a size, tap add,
// the cart drawer opens. We post to /cart/add.js and ask Shopify to re-render
// Dawn's cart sections in the same round trip, then hand them to <cart-drawer>
// exactly as Dawn's own product form does. Without a drawer in the theme we
// fall back to refreshing the cart count in place.

(function () {
  'use strict';

  var ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function setHint(card, message, isError) {
    var hint = card.querySelector('[data-pahar-hint]');
    if (!hint) return;
    hint.textContent = message;
    hint.classList.toggle('is-error', !!isError);
  }

  // Dawn's cart-icon-bubble section is the only bit of chrome we own updating
  // when there's no drawer to render into.
  function refreshCartCount() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var html = data['cart-icon-bubble'];
        if (!html) return;
        var target = document.getElementById('cart-icon-bubble');
        if (target) {
          target.innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('.shopify-section').innerHTML;
        }
        var count = document.querySelector('.pahar-header__cart-count');
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('.cart-count-bubble span');
        if (count && fresh) count.textContent = fresh.textContent.trim();
      })
      .catch(function () {});
  }

  function initCard(card) {
    var addButton = card.querySelector('[data-pahar-add]');
    var sizes = card.querySelectorAll('[data-pahar-size]');
    var selected = null;

    // A single available size needs no choosing — preselect it.
    var available = [];
    for (var i = 0; i < sizes.length; i++) {
      if (!sizes[i].disabled) available.push(sizes[i]);
    }
    if (available.length === 1) {
      available[0].setAttribute('aria-pressed', 'true');
      selected = available[0].getAttribute('data-variant-id');
      setHint(card, '');
    }

    for (var j = 0; j < sizes.length; j++) {
      sizes[j].addEventListener('click', function (event) {
        var button = event.currentTarget;
        for (var k = 0; k < sizes.length; k++) {
          sizes[k].setAttribute('aria-pressed', sizes[k] === button ? 'true' : 'false');
        }
        selected = button.getAttribute('data-variant-id');
        setHint(card, '');
      });
    }

    if (!addButton) return;

    addButton.addEventListener('click', function () {
      if (!selected) {
        setHint(card, 'Choose a size first', true);
        var fieldset = card.querySelector('[data-pahar-sizes]');
        if (fieldset) {
          fieldset.classList.remove('pahar-shop__sizes--nudge');
          // Reflow so the nudge replays on a second click.
          void fieldset.offsetWidth;
          fieldset.classList.add('pahar-shop__sizes--nudge');
        }
        return;
      }

      var cartDrawer = drawer();
      var body = { items: [{ id: Number(selected), quantity: 1 }] };
      if (cartDrawer) {
        body.sections = cartDrawer
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .join(',');
        body.sections_url = window.location.pathname;
        cartDrawer.setActiveElement(document.activeElement);
      }

      card.classList.add('is-adding');
      addButton.disabled = true;

      fetch(ADD_URL + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status) {
            setHint(card, data.description || data.message || 'Could not add that', true);
            return;
          }
          if (cartDrawer && data.sections) {
            cartDrawer.renderContents(data);
          } else {
            refreshCartCount();
            setHint(card, 'Added to your bag');
          }
          document.dispatchEvent(new CustomEvent('pahar:added'));
        })
        .catch(function () {
          setHint(card, 'Something went wrong — try again', true);
        })
        .then(function () {
          card.classList.remove('is-adding');
          addButton.disabled = false;
        });
    });
  }

  function boot() {
    var cards = document.querySelectorAll('[data-pahar-card]');
    for (var i = 0; i < cards.length; i++) initCard(cards[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
